import React, {memo} from "react"
import s from "./backButton.module.scss"
import {IoIosArrowBack} from "react-icons/io"

type PropsTypes = {
    onClick: () => void
}
export const BackButton: React.FC<PropsTypes> = memo(({onClick}) => {
    return (
        <div className={s.container} onClick={onClick}>
            <IoIosArrowBack size={18}/>
            <span className={s.text}>Назад</span>
        </div>
    )
})
